export default "/react/logoTextru-1ea9c51f.png";